// extracted by mini-css-extract-plugin
export var discard = "_2s-3";
export var muiTooltipTooltip = "_2s-5";
export var notificationBar = "_2s-2";
export var saveButtonHoverSlotWrapper = "_2s-4";
export var show = "_2s-1";
export var spacer = "_2s-0";